import { c as _c } from "react/compiler-runtime";
import { Checkbox, CurrencyEnum, FormInput, FormInputSearch, FormSelect, Popover, Tooltip } from '@systemeio/ui';
import { CheckCircleIcon, QuestionMarkIcon, TimeCircleIcon } from '@systemeio/ui/icons';
import { FUNNELS_API, activateFunnel, createFunnel, removeFunnel, updateFunnel } from 'modules/funnels/api/funnels-api';
import { updateSaleSettings } from 'modules/funnels/api/sale-settings-api';
import FunnelDuplicateModal from 'modules/funnels/components/funnel-duplicate-modal';
import FunnelGoalSelector from 'modules/funnels/components/funnel-goal-selector';
import { FunnelsLoco } from 'modules/funnels/constants/funnels-loco';
import { useOfferFormSettingsMutation } from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/hooks/use-offer-form-settings';
import { useFunnel } from 'modules/funnels/funnel/hooks/use-funnel';
import { useSaleSettings } from 'modules/funnels/funnel/hooks/use-sale-settings';
import { useFunnelStepsList } from 'modules/funnels/funnel/hooks/use-funnel-steps-list';
import { useFunnels } from 'modules/funnels/hooks/use-funnels';
import { FunnelFilterInterface, StatusDataInterface } from 'modules/funnels/types/funnel-filter-interface';
import { FunnelAdditionalEditableInterface, FunnelCreateInterface, FunnelEditableInterface, FunnelErrorsInterface, FunnelInterface, FunnelSettingsEditableInterface } from 'modules/funnels/types/funnel-interface';
import { getFunnelUrl } from 'modules/funnels/utils/get-funnel-url';
import { isFunnelCreated } from 'modules/funnels/utils/is-funnel-created';
import { usePaymentSettings } from 'modules/profile/payment/hooks/use-payment-settings';
import { ShareResourceEnum } from 'modules/share/enum/share-resource-enum';
import { getShareUrl } from 'modules/share/utils/get-share-url';
import { NextPage } from 'next';
import { useEffect, useState } from 'react';
import { CreateDataType } from 'shared/components/create-modal';
import LinkShareModal from 'shared/components/link-share-modal';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import ListingLayout from 'shared/components/listing-layout';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import TransLoco from 'shared/components/trans-loco';
import { removeFunnelStepInDB } from 'shared/db/utils/funnels';
import { BooleanStatusEnum } from 'shared/enums/status-enum';
import { useCurrencyData } from 'shared/hooks/use-currency-data';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useUpdateData } from 'shared/hooks/use-update-data';
import useUser from 'shared/hooks/use-user';
import useUserDomains from 'shared/hooks/use-user-domains';
import { useFilterPagination } from 'shared/route-query/hooks/use-filter-pagination';
import { dateTimeFormat } from 'shared/utils/date-time-format';
import { fetchWithErrors } from 'shared/utils/fetch-with-errors';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
import { getDomainInfoLink } from 'shared/utils/get-domain-info-link';
import { usePaymentMethodsByCurrency } from '../../shared/hooks/use-payment-methods-by-currency';
import { allowedPaymentMethodsFunnels } from 'modules/funnels/funnel/constants/allowed-payment-methods';
const defaultErrors: FunnelErrorsInterface = {
  name: '',
  domain: '',
  currency: '',
  type: '',
  paymentMethods: '',
  disableTax: ''
};
const defaultFilters: FunnelFilterInterface = {
  search: '',
  status: 'true'
};
const Funnels: NextPage = () => {
  const $ = _c(215);
  const {
    user,
    isWsAssistant
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  const {
    userDomains,
    userDomainsSelect,
    userDefaultDomain
  } = useUserDomains();
  const {
    filter,
    setFilter,
    pagination,
    setPagination,
    limit,
    setLimit
  } = useFilterPagination(defaultFilters);
  const {
    paymentSettingsData
  } = usePaymentSettings(!isWsAssistant);
  const [errors, setErrors] = useState(defaultErrors);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      name: "",
      currency: undefined,
      domain: undefined,
      type: undefined
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [defaultValues, setDefaultValues] = useState(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      paymentMethods: undefined,
      domain: undefined,
      currency: undefined
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [additionalData, setAdditionalData] = useState(t1);
  let t2;
  if ($[2] !== filter || $[3] !== limit || $[4] !== pagination) {
    t2 = {
      limit,
      pagination,
      filter
    };
    $[2] = filter;
    $[3] = limit;
    $[4] = pagination;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    funnels,
    mutate,
    counter
  } = useFunnels(t2);
  const [funnelId, setFunnelId] = useState();
  const {
    funnel,
    mutateFunnel
  } = useFunnel(funnelId);
  const {
    saleSettings,
    mutateSaleSettings
  } = useSaleSettings(funnel?.saleSettingsId);
  const {
    funnelStepsList
  } = useFunnelStepsList(funnelId);
  const t3 = saleSettings?.currency;
  let t4;
  if ($[6] !== t) {
    t4 = t("dashboard.funnel.currency_change_info");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== errors || $[9] !== t3 || $[10] !== t4) {
    t5 = {
      currency: t3,
      currencyChangeMessage: t4,
      errors,
      allowedPaymentMethods: allowedPaymentMethodsFunnels
    };
    $[8] = errors;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const {
    currencyAndPaymentMethodsEditFields
  } = usePaymentMethodsByCurrency(t5);
  let t6;
  if ($[12] !== funnels?.items) {
    t6 = () => {
      const array = funnels?.items.map(_temp);
      return array || [];
    };
    $[12] = funnels?.items;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const getStaticFunnelItems = t6;
  let t7;
  if ($[14] !== getStaticFunnelItems) {
    t7 = [`${FUNNELS_API}/get-payment-methods`, ...getStaticFunnelItems()];
    $[14] = getStaticFunnelItems;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== setPagination || $[17] !== t7) {
    t8 = {
      setPagination,
      api: FUNNELS_API,
      constantApi: t7
    };
    $[16] = setPagination;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const updateData = useUpdateData(t8);
  let t9;
  if ($[19] !== funnels || $[20] !== updateData) {
    t9 = async () => {
      await updateData(false, funnels);
    };
    $[19] = funnels;
    $[20] = updateData;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const onUpdateData = t9;
  const currencyData = useCurrencyData();
  let t10;
  if ($[22] !== paymentSettingsData || $[23] !== userDefaultDomain) {
    t10 = () => {
      if (userDefaultDomain) {
        setDefaultValues(prev => ({
          ...prev,
          domain: userDefaultDomain.id
        }));
      }
      if (paymentSettingsData) {
        setDefaultValues(prev_0 => ({
          ...prev_0,
          currency: paymentSettingsData.defaultCurrency
        }));
      }
    };
    $[22] = paymentSettingsData;
    $[23] = userDefaultDomain;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== paymentSettingsData || $[26] !== userDefaultDomain || $[27] !== userDomains) {
    t11 = [userDomains, paymentSettingsData, userDefaultDomain];
    $[25] = paymentSettingsData;
    $[26] = userDefaultDomain;
    $[27] = userDomains;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  useEffect(t10, t11);
  let t12;
  let t13;
  if ($[29] !== funnel) {
    t12 = () => {
      if (funnel) {
        setAdditionalData({
          domain: funnel.domain.id
        });
      }
    };
    t13 = [funnel];
    $[29] = funnel;
    $[30] = t12;
    $[31] = t13;
  } else {
    t12 = $[30];
    t13 = $[31];
  }
  useEffect(t12, t13);
  let t14;
  let t15;
  if ($[32] !== saleSettings) {
    t14 = () => {
      if (saleSettings) {
        setAdditionalData(prev_1 => ({
          ...prev_1,
          currency: saleSettings.currency,
          paymentMethods: saleSettings.paymentMethods,
          disableTax: saleSettings.disableTax
        }));
      }
    };
    t15 = [saleSettings];
    $[32] = saleSettings;
    $[33] = t14;
    $[34] = t15;
  } else {
    t14 = $[33];
    t15 = $[34];
  }
  useEffect(t14, t15);
  let t16;
  if ($[35] !== t) {
    t16 = () => Object.keys(BooleanStatusEnum).map(key => {
      const status = key as keyof typeof BooleanStatusEnum;
      return {
        id: status,
        caption: t(BooleanStatusEnum[status])
      };
    });
    $[35] = t;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  const getStatusData = t16;
  let t17;
  if ($[37] !== t) {
    t17 = t("global.title");
    $[37] = t;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t17) {
    t18 = {
      key: "name",
      header: t17,
      widthPercent: 73,
      onRender: _temp2
    };
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== t) {
    t19 = t("global.status");
    $[41] = t;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== t) {
    t20 = funnel_1 => {
      const StatusOfCreatedFunnel = <Tooltip label={funnel_1.active ? t("global.active") : t("global.inactive")} mode="hover" key="status-tooltip"><CheckCircleIcon className={`h-[16px] w-[16px] sm:h-[20px] sm:w-[20px] ${funnel_1.active && "fill-green"}`} /></Tooltip>;
      const StatusOfNotCreatedFunnel = <Tooltip label={t("dashboard.funnel.creation_in_process")} mode="hover" key="status-tooltip"><TimeCircleIcon className="fill-yellow h-[16px] w-[16px] sm:h-[20px] sm:w-[20px]" /></Tooltip>;
      return <div className="flex items-center lg:ml-4">{isFunnelCreated(funnel_1) ? StatusOfCreatedFunnel : StatusOfNotCreatedFunnel}</div>;
    };
    $[43] = t;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== t19 || $[46] !== t20) {
    t21 = {
      key: "status",
      header: t19,
      widthPercent: 10,
      onRender: t20
    };
    $[45] = t19;
    $[46] = t20;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== t) {
    t22 = t("global.created_on");
    $[48] = t;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== user?.dateFormat || $[51] !== user?.timeFormat || $[52] !== user?.timezone) {
    t23 = funnel_2 => <span>{dateTimeFormat(funnel_2.createdAt, {
        timeFormat: user?.timeFormat,
        dateFormat: user?.dateFormat,
        timeZone: user?.timezone
      })}</span>;
    $[50] = user?.dateFormat;
    $[51] = user?.timeFormat;
    $[52] = user?.timezone;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== t22 || $[55] !== t23) {
    t24 = {
      key: "funnel.createdAt",
      header: t22,
      widthPercent: 17,
      onRender: t23
    };
    $[54] = t22;
    $[55] = t23;
    $[56] = t24;
  } else {
    t24 = $[56];
  }
  let t25;
  if ($[57] !== t18 || $[58] !== t21 || $[59] !== t24) {
    t25 = [t18, t21, t24];
    $[57] = t18;
    $[58] = t21;
    $[59] = t24;
    $[60] = t25;
  } else {
    t25 = $[60];
  }
  const columns = t25;
  let t26;
  if ($[61] !== defaultValues || $[62] !== funnels || $[63] !== updateData) {
    t26 = async data => {
      await fetchWithErrors(async () => {
        const newData = {
          ...data,
          currency: data.currency || defaultValues.currency || CurrencyEnum.EURO
        };
        await createFunnel(newData);
        await updateData(true, funnels);
      }, setErrors);
    };
    $[61] = defaultValues;
    $[62] = funnels;
    $[63] = updateData;
    $[64] = t26;
  } else {
    t26 = $[64];
  }
  const onCreateFunnel = t26;
  const {
    clearCurrencyRelatedFields
  } = useOfferFormSettingsMutation();
  let t27;
  if ($[65] !== clearCurrencyRelatedFields || $[66] !== funnelStepsList || $[67] !== funnels || $[68] !== mutate || $[69] !== mutateFunnel || $[70] !== mutateSaleSettings || $[71] !== saleSettings?.currency || $[72] !== updateData) {
    t27 = async (funnel_3, data_0) => {
      await fetchWithErrors(async () => {
        if (!funnel_3.saleSettingsId) {
          return;
        }
        const newFunnelData = {
          name: data_0.name,
          domain: data_0.domain
        };
        const salesSettingsData = {
          currency: data_0.currency,
          paymentMethods: data_0.paymentMethods,
          disableTax: data_0.disableTax || false
        };
        const [funnelResponse, saleSettingsResponse] = await Promise.all([updateFunnel(funnel_3.id, newFunnelData), updateSaleSettings(funnel_3.saleSettingsId, salesSettingsData)]);
        await updateData(false, undefined, {
          mutationData: funnels,
          onMutate: async () => {
            await mutate(data_1 => {
              if (data_1) {
                return {
                  items: data_1.items.map(item => {
                    if (item.id === funnel_3.id) {
                      item = {
                        ...item,
                        name: funnelResponse.data.name
                      };
                    }
                    return item;
                  }),
                  hasMore: data_1.hasMore
                };
              }
            }, false);
            await mutateSaleSettings(saleSettingsResponse.data, false);
          }
        });
        await mutateFunnel(data_2 => {
          if (data_2) {
            return {
              ...data_2,
              name: funnelResponse.data.name,
              domain: funnelResponse.data.domain
            };
          }
        }, false);
        if (saleSettings?.currency !== saleSettingsResponse.data.currency) {
          if (!funnelStepsList) {
            return;
          }
          await clearCurrencyRelatedFields(funnelStepsList.map(_temp3));
        }
      }, setErrors);
    };
    $[65] = clearCurrencyRelatedFields;
    $[66] = funnelStepsList;
    $[67] = funnels;
    $[68] = mutate;
    $[69] = mutateFunnel;
    $[70] = mutateSaleSettings;
    $[71] = saleSettings?.currency;
    $[72] = updateData;
    $[73] = t27;
  } else {
    t27 = $[73];
  }
  const onUpdateFunnel = t27;
  let t28;
  if ($[74] !== funnels || $[75] !== mutate || $[76] !== updateData) {
    t28 = async funnel_4 => {
      await activateFunnel(funnel_4.id, funnel_4.active);
      await updateData(false, undefined, {
        mutationData: funnels,
        onMutate: async () => {
          await mutate(data_3 => {
            if (data_3) {
              return {
                items: data_3.items.map(item_0 => {
                  if (item_0.id === funnel_4.id) {
                    item_0 = {
                      ...item_0,
                      active: !funnel_4.active
                    };
                  }
                  return item_0;
                }),
                hasMore: data_3.hasMore
              };
            }
          }, false);
        }
      });
    };
    $[74] = funnels;
    $[75] = mutate;
    $[76] = updateData;
    $[77] = t28;
  } else {
    t28 = $[77];
  }
  const onActivateFunnel = t28;
  let t29;
  if ($[78] !== onUpdateData) {
    t29 = async funnel_5 => {
      await removeFunnel(funnel_5.id);
      await removeFunnelStepInDB(funnel_5.id);
      await onUpdateData();
    };
    $[78] = onUpdateData;
    $[79] = t29;
  } else {
    t29 = $[79];
  }
  const onRemoveFunnel = t29;
  let t30;
  if ($[80] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = () => setErrors(defaultErrors);
    $[80] = t30;
  } else {
    t30 = $[80];
  }
  const onModalClose = t30;
  let t31;
  if ($[81] !== t) {
    t31 = t("dashboard.funnel.title_plural");
    $[81] = t;
    $[82] = t31;
  } else {
    t31 = $[82];
  }
  let t32;
  if ($[83] !== t) {
    t32 = t("dashboard.funnel.title_tooltip");
    $[83] = t;
    $[84] = t32;
  } else {
    t32 = $[84];
  }
  let t33;
  if ($[85] !== t32) {
    t33 = <Popover label={t32} popoverClassName="w-[200px] sm:w-[350px]">{_temp4}</Popover>;
    $[85] = t32;
    $[86] = t33;
  } else {
    t33 = $[86];
  }
  let t34;
  if ($[87] !== t31 || $[88] !== t33) {
    t34 = <h1 className="flex items-center gap-1.5">{t31}{t33}</h1>;
    $[87] = t31;
    $[88] = t33;
    $[89] = t34;
  } else {
    t34 = $[89];
  }
  let t35;
  if ($[90] !== filter || $[91] !== setFilter) {
    t35 = {
      filter,
      setFilter,
      defaultFilters
    };
    $[90] = filter;
    $[91] = setFilter;
    $[92] = t35;
  } else {
    t35 = $[92];
  }
  let t36;
  if ($[93] !== pagination || $[94] !== setPagination) {
    t36 = {
      pagination,
      setPagination
    };
    $[93] = pagination;
    $[94] = setPagination;
    $[95] = t36;
  } else {
    t36 = $[95];
  }
  let t37;
  if ($[96] !== limit || $[97] !== setLimit) {
    t37 = {
      limit,
      setLimit
    };
    $[96] = limit;
    $[97] = setLimit;
    $[98] = t37;
  } else {
    t37 = $[98];
  }
  let t38;
  if ($[99] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = {
      field: "search",
      onRender: _temp5
    };
    $[99] = t38;
  } else {
    t38 = $[99];
  }
  let t39;
  if ($[100] !== getStatusData) {
    t39 = [t38, {
      field: "status",
      onRender: (value_0, onChange_0) => <FormSelect key="funnel-status-filter" data={getStatusData()} onChange={data_4 => onChange_0(data_4)} value={value_0} />
    }];
    $[100] = getStatusData;
    $[101] = t39;
  } else {
    t39 = $[101];
  }
  let t40;
  if ($[102] !== t35 || $[103] !== t36 || $[104] !== t37 || $[105] !== t39) {
    t40 = {
      filterer: t35,
      paginator: t36,
      limiter: t37,
      testAttributePostfix: "filter-btn",
      filterable: t39
    };
    $[102] = t35;
    $[103] = t36;
    $[104] = t37;
    $[105] = t39;
    $[106] = t40;
  } else {
    t40 = $[106];
  }
  let t41;
  if ($[107] !== onCreateFunnel) {
    t41 = data_5 => onCreateFunnel(data_5);
    $[107] = onCreateFunnel;
    $[108] = t41;
  } else {
    t41 = $[108];
  }
  let t42;
  if ($[109] !== t) {
    t42 = t("dashboard.funnel.title");
    $[109] = t;
    $[110] = t42;
  } else {
    t42 = $[110];
  }
  let t43;
  if ($[111] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = ["name", "domain", "type"];
    $[111] = t43;
  } else {
    t43 = $[111];
  }
  let t44;
  if ($[112] !== errors || $[113] !== t) {
    t44 = {
      field: "name",
      onRender: (value_1, onChange_1) => <FormInput key="funnel-name-create" label={t("global.name")} placeholder={t("global.name")} required={true} value={value_1} onChange={e_0 => onChange_1(e_0.target.value)} maxLength={256} error={errors.name} data-test="funnel-name-field" />
    };
    $[112] = errors;
    $[113] = t;
    $[114] = t44;
  } else {
    t44 = $[114];
  }
  let t45;
  if ($[115] !== errors || $[116] !== t || $[117] !== user?.dashboardLocale || $[118] !== userDomainsSelect) {
    t45 = {
      field: "domain",
      onRender: (value_2, onChange_2) => <FormSelect key="funnel-domain-create" label={<div className="flex items-center gap-1">{t("dashboard.funnel.funnel_domain")}<Popover label={<TransLoco t={t} i18nKey="dashboard.funnel.domain_tooltip" components={{
          a: <a rel="noreferrer" target="_blank" className="primary-link w-full" href={getDomainInfoLink(user?.dashboardLocale)} />
        }} />} popoverClassName="w-[200px] sm:w-[350px]">{_temp6}</Popover></div>} required={true} data={userDomainsSelect} onChange={data_6 => onChange_2(data_6)} value={value_2} error={errors.domain} />
    };
    $[115] = errors;
    $[116] = t;
    $[117] = user?.dashboardLocale;
    $[118] = userDomainsSelect;
    $[119] = t45;
  } else {
    t45 = $[119];
  }
  let t46;
  if ($[120] !== t44 || $[121] !== t45) {
    t46 = [t44, t45];
    $[120] = t44;
    $[121] = t45;
    $[122] = t46;
  } else {
    t46 = $[122];
  }
  let t47;
  if ($[123] !== errors) {
    t47 = {
      field: "type",
      onRender: (value_3, onChange_3) => <FunnelGoalSelector key="funnel-type-create" value={value_3} onChange={onChange_3} error={errors.type} />
    };
    $[123] = errors;
    $[124] = t47;
  } else {
    t47 = $[124];
  }
  let t48;
  if ($[125] !== currencyData || $[126] !== errors || $[127] !== t) {
    t48 = {
      field: "currency",
      onRender: (value_4, onChange_4) => <FormSelect key="funnel-currency-create" label={t("global.currency")} data={currencyData} onChange={data_7 => onChange_4(data_7)} value={value_4} error={errors.currency} />
    };
    $[125] = currencyData;
    $[126] = errors;
    $[127] = t;
    $[128] = t48;
  } else {
    t48 = $[128];
  }
  let t49;
  if ($[129] !== t46 || $[130] !== t47 || $[131] !== t48) {
    t49 = [t46, t47, t48];
    $[129] = t46;
    $[130] = t47;
    $[131] = t48;
    $[132] = t49;
  } else {
    t49 = $[132];
  }
  let t50;
  if ($[133] !== defaultValues || $[134] !== t41 || $[135] !== t42 || $[136] !== t49) {
    t50 = {
      onCreate: t41,
      defaultValues,
      caption: t42,
      onAfterLeave: onModalClose,
      requiredFields: t43,
      testAttributePostfix: "create-btn",
      dataTestKey: "funnel",
      creatable: t49
    };
    $[133] = defaultValues;
    $[134] = t41;
    $[135] = t42;
    $[136] = t49;
    $[137] = t50;
  } else {
    t50 = $[137];
  }
  let t51;
  if ($[138] !== t) {
    t51 = t("dashboard.funnel.title");
    $[138] = t;
    $[139] = t51;
  } else {
    t51 = $[139];
  }
  let t52;
  if ($[140] !== limit || $[141] !== setLimit) {
    t52 = {
      limit,
      setLimit
    };
    $[140] = limit;
    $[141] = setLimit;
    $[142] = t52;
  } else {
    t52 = $[142];
  }
  let t53;
  if ($[143] !== pagination || $[144] !== setPagination) {
    t53 = {
      pagination,
      setPagination
    };
    $[143] = pagination;
    $[144] = setPagination;
    $[145] = t53;
  } else {
    t53 = $[145];
  }
  let t54;
  let t55;
  if ($[146] === Symbol.for("react.memo_cache_sentinel")) {
    t54 = ["openLink", "custom", "activate", "settings", "remove"];
    t55 = [{
      shouldRender: _temp7,
      name: "view-funnel",
      openInNew: true,
      setHref: _temp8
    }];
    $[146] = t54;
    $[147] = t55;
  } else {
    t54 = $[146];
    t55 = $[147];
  }
  let t56;
  if ($[148] !== t) {
    t56 = t("dashboard.actions.title.duplicate");
    $[148] = t;
    $[149] = t56;
  } else {
    t56 = $[149];
  }
  let t57;
  if ($[150] !== onUpdateData) {
    t57 = (opened, onClose, funnel_9, key_0) => <FunnelDuplicateModal key={key_0} opened={opened} onClose={() => {
      onModalClose();
      onClose();
    }} funnel={funnel_9} onUpdateData={onUpdateData} />;
    $[150] = onUpdateData;
    $[151] = t57;
  } else {
    t57 = $[151];
  }
  let t58;
  if ($[152] !== t56 || $[153] !== t57) {
    t58 = {
      shouldRender: _temp9,
      name: "duplicate",
      caption: t56,
      onActionRender: t57
    };
    $[152] = t56;
    $[153] = t57;
    $[154] = t58;
  } else {
    t58 = $[154];
  }
  let t59;
  if ($[155] !== t) {
    t59 = t("dashboard.actions.title.share");
    $[155] = t;
    $[156] = t59;
  } else {
    t59 = $[156];
  }
  let t60;
  if ($[157] !== t) {
    t60 = (opened_0, onClose_0, funnel_11, key_1) => <LinkShareModal opened={opened_0} link={getShareUrl(ShareResourceEnum.Funnel, funnel_11.hash)} label={t("dashboard.funnel.share_link")} title={t("dashboard.funnel.share_funnel")} onClose={onClose_0} key={key_1} />;
    $[157] = t;
    $[158] = t60;
  } else {
    t60 = $[158];
  }
  let t61;
  if ($[159] !== t59 || $[160] !== t60) {
    t61 = {
      shouldRender: _temp10,
      name: "share",
      caption: t59,
      onActionRender: t60
    };
    $[159] = t59;
    $[160] = t60;
    $[161] = t61;
  } else {
    t61 = $[161];
  }
  let t62;
  if ($[162] !== t58 || $[163] !== t61) {
    t62 = [t58, t61];
    $[162] = t58;
    $[163] = t61;
    $[164] = t62;
  } else {
    t62 = $[164];
  }
  let t63;
  if ($[165] !== onActivateFunnel) {
    t63 = {
      shouldRender: _temp11,
      onChange: funnel_13 => onActivateFunnel(funnel_13)
    };
    $[165] = onActivateFunnel;
    $[166] = t63;
  } else {
    t63 = $[166];
  }
  let t64;
  if ($[167] !== t) {
    t64 = t("dashboard.funnel.edit_funnel");
    $[167] = t;
    $[168] = t64;
  } else {
    t64 = $[168];
  }
  let t65;
  if ($[169] === Symbol.for("react.memo_cache_sentinel")) {
    t65 = funnelInstance => {
      setFunnelId(funnelInstance.id);
    };
    $[169] = t65;
  } else {
    t65 = $[169];
  }
  const t66 = !funnel || !saleSettings;
  let t67;
  if ($[170] !== errors || $[171] !== t) {
    t67 = {
      field: "name",
      onRender: (value_5, onChange_5, _, __, isPreFetching) => <FormInput isPreFetching={isPreFetching} key="funnel-name-edit" label={t("global.name")} placeholder={t("global.name")} value={value_5} onChange={e_1 => onChange_5(e_1.target.value)} maxLength={256} error={errors.name} />
    };
    $[170] = errors;
    $[171] = t;
    $[172] = t67;
  } else {
    t67 = $[172];
  }
  let t68;
  if ($[173] !== errors || $[174] !== t || $[175] !== user?.dashboardLocale || $[176] !== userDomainsSelect) {
    t68 = [{
      field: "domain",
      onRender: (value_6, onChange_6, __0, ___0, isPreFetching_0) => <FormSelect isPreFetching={isPreFetching_0} key="funnel-domain-edit" label={<div className="flex w-fit items-center gap-1">{t("dashboard.funnel.funnel_domain")}<Popover label={<TransLoco t={t} i18nKey="dashboard.funnel.domain_tooltip" components={{
          a: <a rel="noreferrer" target="_blank" className="primary-link w-full" href={getDomainInfoLink(user?.dashboardLocale)} />
        }} />} popoverClassName="w-[200px] sm:w-[350px]">{_temp13}</Popover></div>} data={userDomainsSelect} onChange={data_8 => onChange_6(data_8)} value={value_6} error={errors.domain} withoutCloseIcon={true} />
    }];
    $[173] = errors;
    $[174] = t;
    $[175] = user?.dashboardLocale;
    $[176] = userDomainsSelect;
    $[177] = t68;
  } else {
    t68 = $[177];
  }
  let t69;
  if ($[178] !== errors || $[179] !== t) {
    t69 = {
      field: "disableTax",
      onRender: (value_7, onChange_7, __1, ___1, isPreFetching_1) => <Checkbox key="funnel-edit-disable-tax" label={t("dashboard.funnel.disable_tax")} value={value_7 || false} onChange={data_9 => onChange_7(data_9)} error={errors.disableTax} isFetching={isPreFetching_1} />
    };
    $[178] = errors;
    $[179] = t;
    $[180] = t69;
  } else {
    t69 = $[180];
  }
  let t70;
  if ($[181] !== currencyAndPaymentMethodsEditFields || $[182] !== t67 || $[183] !== t68 || $[184] !== t69) {
    t70 = [t67, t68, ...currencyAndPaymentMethodsEditFields, t69];
    $[181] = currencyAndPaymentMethodsEditFields;
    $[182] = t67;
    $[183] = t68;
    $[184] = t69;
    $[185] = t70;
  } else {
    t70 = $[185];
  }
  let t71;
  if ($[186] !== onUpdateFunnel) {
    t71 = (funnel_15, data_10) => onUpdateFunnel(funnel_15, data_10);
    $[186] = onUpdateFunnel;
    $[187] = t71;
  } else {
    t71 = $[187];
  }
  let t72;
  if ($[188] !== additionalData || $[189] !== t64 || $[190] !== t66 || $[191] !== t70 || $[192] !== t71) {
    t72 = {
      shouldRender: _temp12,
      fullCaption: t64,
      onModalOpen: t65,
      isFetching: t66,
      onModalClose,
      additionalData,
      editable: t70,
      onEdit: t71
    };
    $[188] = additionalData;
    $[189] = t64;
    $[190] = t66;
    $[191] = t70;
    $[192] = t71;
    $[193] = t72;
  } else {
    t72 = $[193];
  }
  let t73;
  if ($[194] !== onRemoveFunnel) {
    t73 = {
      shouldRender: _temp14,
      onChange: onRemoveFunnel
    };
    $[194] = onRemoveFunnel;
    $[195] = t73;
  } else {
    t73 = $[195];
  }
  let t74;
  if ($[196] !== t62 || $[197] !== t63 || $[198] !== t72 || $[199] !== t73) {
    t74 = {
      openLink: t55,
      custom: t62,
      activate: t63,
      settings: t72,
      remove: t73
    };
    $[196] = t62;
    $[197] = t63;
    $[198] = t72;
    $[199] = t73;
    $[200] = t74;
  } else {
    t74 = $[200];
  }
  let t75;
  if ($[201] !== columns || $[202] !== funnels || $[203] !== t51 || $[204] !== t52 || $[205] !== t53 || $[206] !== t74) {
    t75 = <div data-test="funnel-list"><Table data={funnels} columns={columns} caption={t51} limiter={t52} paginator={t53} testAttributePostfix="funnel" actionsOrder={t54} actions={t74} /></div>;
    $[201] = columns;
    $[202] = funnels;
    $[203] = t51;
    $[204] = t52;
    $[205] = t53;
    $[206] = t74;
    $[207] = t75;
  } else {
    t75 = $[207];
  }
  let t76;
  if ($[208] !== counter || $[209] !== funnels || $[210] !== t34 || $[211] !== t40 || $[212] !== t50 || $[213] !== t75) {
    t76 = <ListingLayout counter={counter} data={funnels} title={t34} type="compact" filterData={t40} createData={t50}>{t75}</ListingLayout>;
    $[208] = counter;
    $[209] = funnels;
    $[210] = t34;
    $[211] = t40;
    $[212] = t50;
    $[213] = t75;
    $[214] = t76;
  } else {
    t76 = $[214];
  }
  return t76;
};
export const getServerSideProps = getBaseServerSideProps(FunnelsLoco, 'header.top_menu.funnels');
export default Funnels;
function _temp(el) {
  return `${FUNNELS_API}/${el.id}`;
}
function _temp2(funnel_0) {
  return <div className="truncate">{isFunnelCreated(funnel_0) ? <LinkWithoutPrefetch rel="noreferrer" className="primary-link w-full" href={getFunnelUrl(funnel_0.id)}>{funnel_0.name}</LinkWithoutPrefetch> : <span className="w-full">{funnel_0.name}</span>}</div>;
}
function _temp3(step) {
  return step.id;
}
function _temp4(show) {
  return <QuestionMarkIcon className={`${show ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary`} />;
}
function _temp5(value, onChange) {
  return <FormInputSearch key="funnel-search-filter" onClear={() => onChange("")} className="min-w-[150px]" value={value} onChange={e => onChange(e.target.value)} testAttributePostfix="search-input" />;
}
function _temp6(show_0) {
  return <QuestionMarkIcon className={`${show_0 ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary h-[16px] w-[16px]`} />;
}
function _temp7(funnel_6) {
  return isFunnelCreated(funnel_6);
}
function _temp8(funnel_7) {
  return funnel_7.viewLinkUrl;
}
function _temp9(funnel_8) {
  return isFunnelCreated(funnel_8);
}
function _temp10(funnel_10) {
  return isFunnelCreated(funnel_10);
}
function _temp11(funnel_12) {
  return isFunnelCreated(funnel_12);
}
function _temp12(funnel_14) {
  return isFunnelCreated(funnel_14);
}
function _temp13(show_1) {
  return <QuestionMarkIcon className={`${show_1 ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary h-[16px] w-[16px]`} />;
}
function _temp14(funnel_16) {
  return isFunnelCreated(funnel_16);
}